import { useEffect, useState, useRef } from 'react'
import {
  downloadImages,
  createImageMatrix,
} from '@aftermarket-autoparts-alliance/360-images'

export interface ImageFile {
  name: string
  data: Blob
  url: string
}

interface Props {
  url: string
}

interface Response {
  images: ImageFile[][]
  loading: boolean
}

export const useImage360 = ({ url }: Props): Response => {
  const [matrix, setMatrix] = useState<ImageFile[][]>()
  const [loading, setLoading] = useState<boolean>(false)
  const prevUrlRef = useRef<string | null>(null)

  useEffect(() => {
    if (!url || prevUrlRef.current === url) return

    setLoading(true)
    downloadImages({ url }).then((fetchedImages) => {
      setMatrix(createImageMatrix(fetchedImages))
      setLoading(false)
      prevUrlRef.current = url
    })
  }, [url])

  return { images: matrix || [], loading }
}
